import { Injectable } from '@angular/core';

import { Logger } from './logger';
import { AppInsightsService } from './appinsights.service';

@Injectable({
	providedIn: 'root'
})
export class LoggerProvider {

	constructor(private appInsights: AppInsightsService) { }

	create(groupName: string): Logger {
		return new Logger(groupName, this.appInsights);
	}
}
